<template>
    <div class="evaluation">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: 'mydevice' }">我的设备</el-breadcrumb-item>
            <el-breadcrumb-item>评价机器</el-breadcrumb-item>
        </el-breadcrumb>
        <el-divider />
        <div class="pay_table">
            <div class="tr fr">
                <div class="th fg fs">机器图片</div>
                <div class="th fg fs">机器名称</div>
                <div class="th fg fs">机器别名</div>
                <div class="th fg fs">添加时间</div>
            </div>
            <div class="tr fr">
                <div class="td fg fs fr ac jc">
                    <img :src="device_detail.device_imgs" class="device_imgs" alt />
                </div>
                <div class="td fg fs fr ac jc">{{device_detail.class_name}}</div>
                <div class="td fg fs fr ac jc">{{device_detail.device_name}}</div>
                <div class="td fg fs fr ac jc">{{conversion(device_detail.create_time,2)}}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {},
    data() {
        return {
            device_detail: this.getItem("device_detail", 2)
        };
    },
    created() {},
    watch: {},
    methods: {},
    components: {}
};
</script>

<style scoped lang="scss">
.evaluation {
    .pay_table {
        // height: 100px;
        border: 1px solid #e5e5e5;
        .tr {
            // height: 50px;
            border-bottom: 1px solid #e5e5e5;
            &:nth-of-type(2) {
                border-bottom: none;
            }
            .th {
                background-color: #f0f6ff;
                font-weight: 800;
                line-height: 50px;
                height: 100%;
            }
            .th,
            .td {
                font-size: 14px;
                text-align: center;
                border-right: 1px solid #e5e5e5;
                &:last-child {
                    border-right: none;
                }
            }
            .td {
                width: 25%;
                padding: 10px;
                .device_imgs {
                    width: 100px;
                    height: 100px;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/page/me/myDevice/Evaluation.vue